<template>
  <div class="bubble-card">
    <div class="card-header">
      <div class="project-name" @click="toggleDropdown" :title="proyecto.nombre">
        <font-awesome-icon icon="fas fa-project-diagram" class="icon-project" />
        <span>{{ proyecto.nombre }}</span>
        <font-awesome-icon
          v-if="proyecto.proyecto_cerrado"
          icon="fas fa-lock"
          class="closed-icon"
        />
      </div>
      <button class="options-toggle" @click="toggleOptions">
        <font-awesome-icon icon="fa-sliders-h" />
      </button>
    </div>

    <transition name="fade">
      <div v-if="showOptions" class="options-panel">
        <div class="search-wrapper">
          <input
            type="text"
            v-model="searchQuery"
            placeholder="Buscar proyectos..."
            class="search-input"
          />
          <font-awesome-icon
            icon="fas fa-times-circle"
            v-if="searchQuery"
            class="clear-icon"
            @click="clearSearch"
          />
        </div>
        <div class="filters-panel">
          <label class="checkbox-label">
            <input type="checkbox" v-model="filtroActivo" />
            Mostrar proyectos cerrados
          </label>
        </div>
      </div>
    </transition>

    <transition name="fade">
      <div v-if="showDropdown" class="dropdown-container">
        <ul class="dropdown-list">
          <li
            v-for="titulo in filteredProjects"
            :key="titulo.id"
            class="dropdown-item"
            @click.stop="selectProject(titulo)"
            :title="titulo.nombre"
          >
            <font-awesome-icon
              v-if="titulo.proyecto_cerrado"
              icon="fas fa-lock"
              class="closed-icon"
            />
            {{ titulo.nombre }}
          </li>
        </ul>
      </div>
    </transition>

    <div
      v-if="proyecto.proyecto_cerrado"
      role="alert"
      class="mensaje-finalizado alert-closed"
    >
      <font-awesome-icon icon="fas fa-exclamation-circle" class="me-2" />
      <strong>Proyecto Cerrado. Solo lectura.</strong>
    </div>

    <div class="nav-buttons">
      <button class="nav-btn prev" @click="navegarAnterior">
        <font-awesome-icon icon="fas fa-chevron-left" />
      </button>
      <button class="nav-btn next" @click="navegarSiguiente">
        <font-awesome-icon icon="fas fa-chevron-right" />
      </button>
    </div>
  </div>
</template>

<script>
import axios from "@/axios";

export default {
  name: "ProjectHeader",
  props: {
    proyecto: Object,
  },
  data() {
    return {
      showDropdown: false,
      showOptions: false,
      titulosProyectos: [],
      clubActual: this.$store.getters.getClubActual,
      searchQuery: "",
      filtroActivo: false,
    };
  },
  computed: {
    filteredProjects() {
      return this.titulosProyectos.filter((p) => {
        const matchesSearch = p.nombre
          .toLowerCase()
          .includes(this.searchQuery.toLowerCase());
        // Si filtroActivo es true, muestro sólo cerrados; si es false, sólo abiertos
        const matchesClosed = this.filtroActivo
          ? p.proyecto_cerrado
          : !p.proyecto_cerrado;
        return matchesSearch && matchesClosed;
      });
    },
  },
  methods: {
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    toggleOptions() {
      this.showOptions = !this.showOptions;
    },
    selectProject(proyecto) {

      this.$store.commit("setProyectoActual", proyecto);
      this.$store.commit("limpiarEventoActual");
      this.$emit("select-project", proyecto);
      this.showDropdown = false;
    },
    clearSearch() {
      this.searchQuery = "";
    },
    async fetchProyectos() {
      try {
        if (!this.clubActual?.id) {
          console.error("No hay club vinculado");
          return;
        }
        const response = await axios.get("/api/proyectos", {
          params: { club_id: this.clubActual.id },
        });
        this.titulosProyectos = response.data;
        // Si luego de filtrar no queda ninguno, limpiamos selección
        if (this.filteredProjects.length === 0) {
          this.$store.commit("limpiarProyectoActual");
        }
      } catch (error) {
        console.error("Error al cargar proyectos:", error);
      }
    },
    navegarAnterior() {
      const list = this.filteredProjects;
      const idx = list.findIndex((p) => p.id === this.proyecto.id);
      if (idx > 0) this.selectProject(list[idx - 1]);
    },
    navegarSiguiente() {
      const list = this.filteredProjects;
      const idx = list.findIndex((p) => p.id === this.proyecto.id);
      if (idx < list.length - 1) this.selectProject(list[idx + 1]);
    },
  },
  watch: {
    // Cada vez que cambie el filtro o la búsqueda, cerramos y volvemos a abrir el dropdown
    filtroActivo() {
      this.showDropdown = false;
      this.$nextTick(() => (this.showDropdown = true));
    },
    searchQuery() {
      this.showDropdown = false;
      this.$nextTick(() => (this.showDropdown = true));
    },
  },
  created() {
    this.fetchProyectos();
  },
};
</script>


<style scoped>
.bubble-card {
  background-color: #fff;
  border: 1px solid #ced4da;
  border-radius: 15px;
  padding: 0.75rem;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  max-width: 400px;
  margin: auto;
  position: relative;
}

/* Contenedor para los botones de navegación en la parte inferior */
.nav-buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 0.75rem;
}

/* Botones de navegación integrados en la caja */
.nav-btn {
  background-color: #fff;
  border: 1px solid #ced4da;
  border-radius: 50%;
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  color: var(--app-primary);
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.project-name {
  display: flex;
  align-items: center;
  font-size: 1.2rem;
  font-weight: 600;
  cursor: pointer;
}

.icon-project {
  color: var(--app-primary);
  margin-right: 0.5rem;
}

.closed-icon {
  margin-left: 0.5rem;
  color: #dc3545;
}

.options-toggle {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1.4rem;
  color: var(--app-primary);
}

.options-panel {
  margin-top: 0.75rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.search-wrapper {
  position: relative;
  flex: 1;
}

.search-input {
  width: 100%;
  padding: 0.5rem 2rem 0.5rem 0.75rem;
  border: 1px solid #ced4da;
  border-radius: 15px;
  font-size: 1rem;
}

.clear-icon {
  position: absolute;
  right: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  color: #aaa;
  cursor: pointer;
}

.filters-panel {
  font-size: 1rem;
}

.checkbox-label {
  display: flex;
  align-items: center;
}

.dropdown-container {
  background: #fff;
  border: 1px solid #ced4da;
  border-radius: 8px;
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
  margin-top: 0.75rem;
}

.dropdown-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.dropdown-item {
  padding: 0.75rem 1rem;
  cursor: pointer;
  transition: background-color 0.3s ease;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 1rem;
}

.dropdown-item:hover {
  background-color: #f8f9fa;
}

.alert-closed {
  margin-top: 0.75rem;
  padding: 0.75rem;
  background-color: #f8d7da;
  border: 1px solid #f5c2c7;
  border-radius: 8px;
  color: #842029;
  font-size: 1rem;
}

.mensaje-finalizado {
  display: inline-block;
  padding: 0.4rem 0.8rem;
  border: 1px solid #e53935;
  background-color: #ffe0e0;
  color: #e53935;
  border-radius: 8px;
  font-size: 1rem;
}

/* Transición fade */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
